import { render, staticRenderFns } from "./IframeHeader.vue?vue&type=template&id=9db263ea&"
import script from "./IframeHeader.vue?vue&type=script&lang=js&"
export * from "./IframeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports